const fontSizes = {
  lg: "18px",
  "5xl": "46px",
};
export default fontSizes;
